<template >
  <div>
    <!-- 查询表单 start-->
    <div class="main_form">
      <el-form :inline="true" :model="queryModel" size="small" ref="queryForm">
        <el-form-item class="search_form_item" prop="userId">
          <el-input v-model.trim="queryModel.userId" :placeholder="$t('m.live_ID')" clearable></el-input>
        </el-form-item>
        
        <el-form-item class="search_form_item" prop="status">
          <el-select v-model="queryModel.status" :placeholder="$t('m.audit_status')" clearable>
            <el-option :value="0" :label="$t('m.pending_review')"></el-option>
            <el-option :value="1" :label="$t('m.pending_HQ_review')"></el-option>
            <el-option :value="2" :label="$t('m.not_approved')"></el-option>
            <el-option :value="4" :label="$t('m.not_approved_HQ')"></el-option>
            <el-option :value="11" :label="$t('m.withdrawn')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.applyStartTime" type="datetime" 
            value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.apply_time')" 
            style="width:100%"></el-date-picker>
          </el-col>
          <el-col class="coldiv" :span="1">~</el-col>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.applyEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('m.apply_time')" style="width:100%"></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <!-- 按钮 -->
      <div class="btn-wrapper">
        <el-button @click="onQueryBtnClick" type="primary" size="small">{{$t('m.search')}}</el-button>
        <el-button type="text" size="mini" @click="resetForm">{{$t('m.reset')}}</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="main_table">
      <el-table :data="tableData" border style="width: 100%;margin-bottom: 10px;" :row-class-name="tableRowClassName" v-loading="loading.table" ref="tableOrder" :element-loading-text="''"
        element-loading-spinner="el-icon-loading" >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="userId" :label="$t('m.live_ID')"></el-table-column>
        <el-table-column prop="userName" :label="$t('m.sereamer_nickname')"></el-table-column>
        <el-table-column prop="birthday" :label="$t('m.birth')"></el-table-column>
        <el-table-column prop="livePosterList" :label="$t('m.live_record')">
          <template slot-scope="scope" v-if="scope.row.livePosterList&&scope.row.livePosterList.length>0 && scope.row.livePosterList[0].url">
            <img :src="scope.row.livePosterList[0].url" class="img-thumb" @click="showVideoPreviewDialog(scope.row.liveList)">
          </template>
        </el-table-column>
        <el-table-column prop="videoPosterList" :label="$t('m.other_video_materials')">
          <template slot-scope="scope" v-if="scope.row.videoPosterList&&scope.row.videoPosterList.length>0 && scope.row.videoPosterList[0].url">
            <img :src="scope.row.videoPosterList[0].url" class="img-thumb" @click="showVideoPreviewDialog(scope.row.videoList)">
          </template>
        </el-table-column>
        
        <el-table-column prop="email" :label="$t('m.email')" show-overflow-tooltip>
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'emailState')" v-if="scope.row.emailState === false">
            <span v-if="scope.row.emailState === true">{{scope.row.email}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="whatsApp" label="WhatsApp">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'whatsappState')" v-if="scope.row.whatsappState === false">
            <span v-if="scope.row.whatsappState === true">{{scope.row.whatsApp}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="faceBook" label="Facebook">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'facebookState')" v-if="scope.row.facebookState === false">
            <span v-if="scope.row.facebookState === true">{{scope.row.faceBook}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="instagram" label="Instagram">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'instagramState')" v-if="scope.row.instagramState === false">
            <span v-if="scope.row.instagramState === true">{{scope.row.instagram}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" :label="$t('m.phone')">
          <template slot-scope="scope">
            <img width="24" src="../../assets/search.png" @click="getDetailInfo(scope.row,'phoneState')" v-if="scope.row.phoneState === false">
            <span class="direction_ltr" v-if="scope.row.phoneState === true">{{scope.row.areaCode?'+'+scope.row.areaCode:''}}{{scope.row.phone}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lang" :label="$t('m.mastery_lang')">
          <template slot-scope="scope">
            {{scope.row.lang|langFilt}}
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('m.audit_status')" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag type="primary" size="mini" v-if="scope.row.status === 0">{{$t('m.pending_review')}}</el-tag>
            <el-tag type="success" size="mini" v-if="scope.row.status === 1">{{$t('m.pending_HQ_review')}}</el-tag>
            <el-tag type="danger" size="mini" v-if="scope.row.status === 2">{{$t('m.not_approved')}}</el-tag>
            <!-- <el-tag type="success" v-if="scope.row.status === 3">{{$t('m.approved')}}</el-tag> -->
            <el-tag type="danger" size="mini" v-if="scope.row.status === 4">{{$t('m.not_approved_HQ')}}</el-tag>
            <el-tag type="info" size="mini" v-if="scope.row.status === 11">{{$t('m.withdrawn')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="refuseReason" :label="$t('m.rejection_reason')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" :label="$t('m.apply_time')"></el-table-column>
        <el-table-column :label="$t('m.oper')" width="100">
          
          <template slot-scope="scope" v-if="scope.row.status === 0" >
            <el-button type="text" @click="passApplication(scope.row)">{{$t('m.pass')}}</el-button>
            <el-button type="text" @click="rejectCooperation(scope.row)">{{$t('m.refused')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentPageChange" :current-page="pager.page"
        :page-sizes="[10, 20, 30, 100, 300, 500]" :page-size="pager.limit" small layout="total, sizes, prev, pager, next, jumper"
        :total="pager.total" :pager-count="5"></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialog.show" :title="$t('m.reject_streamer_join_agency_apply')" :close-on-click-modal="false" :append-to-body="true" @close="$refs.editForm.resetFields()">
      <el-form :model="dialog.model" :rules="dialog.rules" size="small" ref="editForm"  label-position="left">
        <div style="margin-bottom: 20px;">
          <el-button  type="danger" style="padding:2px; margin-right: 5px;" icon="el-icon-close" circle></el-button>
          <span>{{$t('m.reject_streamer_join_agency',{'msg_ss1':dialog.model.userName,'msg_ss2':guildName})}}</span>
        </div>
        <el-form-item prop="refuseReason" :label="$t('m.rejection_reason')+':'">
          <el-input v-model.trim="dialog.model.refuseReason" type="textarea" :placeholder="$t('m.rejection_reason')" maxlength="50" style="width: 100%;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.show = false" size="small">{{$t('m.cancel')}}</el-button>
        <el-button type="primary" @click="doEdit" size="small" :loading="dialog.btnLoading">{{$t('m.Confirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialog.picture.show" :title="$t('m.preview')+':'" :append-to-body="true" @close="resetInfoForm">
      <div v-loading="dialog.picture.loading">
        <el-carousel :autoplay="false" indicator-position="none" arrow="always">
          <el-carousel-item v-for="(item, index) in dialog.picture.fileList" :key="index">
            <img :src="item.url" v-if="item.type ===2 || item.type === 4 || item.type === 3" class="img-preview">
            <video :src="item.url" v-if="item.type ===0 || item.type ===1" controls="controls" type="video/mp4" class="img-preview"></video>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>
<script>
let queryModelEmpty={
  userId: null,
  status: null,
  applyStartTime: null,
  applyEndTime: null
}
import {
  getApplyList,
  passApply,
} from '../../api/anchor/management';
import {userLangArr,arrToString} from '../../utils/common';
export default {
  components: {},
  inject:['reload'],
  data () {
    return {
      searchBtnTrue: true, // 在生命周期中的列表数据加载完之前搜索按钮是不可点击状态
      guildList: [],
      videoState: false,
      n: 0,
      queryModel: JSON.parse(JSON.stringify(queryModelEmpty)),
      loading: {
        table: true
      },
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      dialog: {
        rules: {
          refuseReason: [
            {required: true, trigger: 'change', message: this.$t('m.no_data')}
          ]
        },
        show: false,
        btnLoading: false,
        model: {
          id: null,
          userName: null,
          refuseReason: null,
          operation: 0
        },
        picture: {
          show: false,
          fileList: []
        },
      },
    }
  },
  filters:{
    langFilt(val){
     return arrToString(val);
    }
  },
  computed: {
    guildName() {
      return (
        this.$store.state.userInfo.guildName
      );
    }
  },
  methods: {
    //重置参数
    resetForm(){
      this.queryModel=JSON.parse(JSON.stringify(queryModelEmpty));
    },
    resetInfoForm() {
      this.dialog.picture.fileList = [];
    },
    showVideoPreviewDialog(row) {
      console.log(row);
      this.dialog.picture.fileList = row;
      this.dialog.picture.show = true;
      this.videoState = true;
    },
    tableRowClassName({row,column,rowIndex}) {
      row.index = rowIndex;
    },
   
   //切换当前参数显示隐藏
    getDetailInfo(row,e) {
      var index = row.index;
      row[e] = true;
      this.$set(this.tableData, index, row);
      this.tableData = this.tableData;
    },
    getPhone(row) {
      var index = row.index;
      row.phoneState = true;
      this.$set(this.tableData, index, row);
      this.tableData = this.tableData;
    },
    activeInputElement() {
      document.activeElement.blur();
      this.$nextTick(() => {
          let inputTime = document.querySelectorAll('.el-input__inner')
          inputTime.forEach(item => {
            item.addEventListener('focus', () => {
              document.activeElement.blur()
            })
          })
        })
    },
    rejectCooperation(row) {
      this.dialog.model.id = row.id;
      this.dialog.model.userName = row.userName;
      // if(row.refuseReason) {
      //   this.dialog.model.refuseReason = row.refuseReason;
      // }else {
      //   this.dialog.model.refuseReason = '您提交的相关资料未通过审核，修改后可再次提交。';
      // }
      this.dialog.show =true;
    },
    // 拒绝
    doEdit() {
      this.$refs.editForm.validate(valid =>{
        if(valid) {
         passApply(this.dialog.model)
         .then(({data}) => {
           if(data.data.detail === 0) {
              this.$message.success(this.$t('m.rejected'));
              this.dialog.show = false;
              this.getTableData();
            }else {
              this.$alert(this.$t('m.oper_failed'),this.$t('m.tip'),{
                confirmButtonText: this.$t('m.i_got_it'),
                callback: () => {
                  this.dialog.show = false;
                  this.getTableData();
                }
              })
            }
         })
         .catch(() =>{})
        }else {
          return false;
        }
      })
    },
    // 通过
    passApplication(row) {
      this.$confirm(this.$t('m.agree_streamer_join_agency',{'msg_ss1':row.userName,'msg_ss2':this.guildName}),this.$t('m.pass_streamer_join_agency_apply'),{
        type: 'success'
      })
      .then(() =>{
        let model = {
          id: row.id,
          operation: 1,
          refuseReason: null
        }
        passApply(model)
        .then(({data}) => {
          if(data.data.detail === 0) {
             this.$message.success(this.$t('m.oper_success'));
             this.getTableData();
           }else {
             this.$alert(this.$t('m.oper_failed'),this.$t('m.tip'),{
               confirmButtonText: this.$t('m.i_got_it'),
               callback: action => {
                  this.getTableData();
                }
             })
           }
        })
        .catch(() =>{})
      })
      .catch(() =>{
        this.getTableData();
      })
    },
    onQueryBtnClick() {
      this.pager.page = 1;
      this.$refs.tableOrder.clearSort();
      this.query();
    },
    query() {
      this.loading.table = true;
      this.getTableData();
    },
    onSizeChange(size) {
      this.pager.limit = size;
      this.query();
    },
    onCurrentPageChange(page) {
      this.pager.page = page;
      this.query();
    },
    getTableData() {
      // 显示表格loading
      console.log(111);
      this.loading.table = true;
      getApplyList({
        query: this.queryModel,
        pager: this.pager,
        sorter: this.sorter
      }).then(({ data }) => {
        let list = data.data.list;
        list.forEach((item,index) => {
          list[index].emailState = false;
          list[index].phoneState = false;
          list[index].whatsappState = false;
          list[index].facebookState = false;
          list[index].instagramState = false;
          list[index].phoneState = false;
          if(item.joinApplyFileEntities && item.joinApplyFileEntities.length>0){
            var liveList = item.joinApplyFileEntities.filter(item => item.type ===0);
            var videoList = item.joinApplyFileEntities.filter(item => item.type ===1);
            var pictrueList = item.joinApplyFileEntities.filter(item => item.type ===2 || item.type===4 || item.type === 3);
            var livePosterList = item.joinApplyFileEntities.filter(item => item.type ===5);
            var videoPosterList = item.joinApplyFileEntities.filter(item => item.type ===6);
            list[index].liveList= liveList;
            list[index].videoList= videoList;
            list[index].pictrueList= pictrueList;
            list[index].livePosterList= livePosterList;
            list[index].videoPosterList= videoPosterList;
          }
        })
        this.tableData=list;
        this.pager.total = data.data.total;
        // 取消loading状态
        this.loading.table = false;
        this.searchBtnTrue = false;
      })
      .catch(error => {
        this.loading.table = false;
      });
    },
  },
  created() {
    this.getTableData();
  }
}
</script>
<style lang="less">
  .main_form {
    margin-bottom: 16px;
    padding: 16px;
    background-color: #FFFFFF;
  }
  .main_table {
    padding: 16px;
    background-color: #FFFFFF;
  }
  .el-tooltip__popper {
    max-width: 200px;
  }
  .el-carousel__container {
      position: relative;
      height: 500px;
  }
  @media screen and (max-width: 991px) {
    .el-carousel__container {
        position: relative;
        height: 400px;
    }
  }
  @media screen and (max-width:768px) {
  	.el-carousel__container {
  	    position: relative;
  	    height: 300px;
  	}
  }
</style>
<style scoped>
.btn-wrapper{
  /* margin-bottom:20px; */
  min-height:40px;
}
/* .btn_style {
  display: flex;
  justify-content: space-between;
  align-items: center;
} */
.btn_style .el-button--small{
  padding: 20px 10px;
  font-size: 20px;
}
.btn_style .el-button--info {
  color: #909399;
  background-color: #fff;
  border-color: #fff;
}
.btn_style .el-button--info:hover {
  color: #909399;
  background-color: #e0e5ee;
  border-color: #e0e5ee;
}
.coldiv{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/anchor/joinGuildManagementPage.vue